<div class="loader-container">
    <app-loader *ngIf="loading == true"></app-loader>
    <app-modal-header *ngIf="modalStyle === true" [title]="modalTitle"></app-modal-header>
    <div [ngClass]="{
        'modal-body': modalStyle === true
    }">
        <div *ngIf="errorMessage && errorMessage.length" class="alert alert-danger d-flex align-items-center"
            role="alert">
            <div>
                {{errorMessage}}
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <label class="form-label">Naam</label>
                <input [ngClass]="{'is-invalid': errors['name']}" type="text" [(ngModel)]="item['name']"
                    class="form-control" placeholder="">
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-6">
                <label class="form-label">EAN</label>
                <input [ngClass]="{'is-invalid': errors['ean']}" type="text" [(ngModel)]="item['ean']"
                    class="form-control" placeholder="">
            </div>
            <div class="col-6">
                <label class="form-label">Prijs</label>
                <input (input)="validatePriceValue($event)" [ngClass]="{'is-invalid': errors['price']}" type="text" [(ngModel)]="item['price']"
                    class="form-control" placeholder="">
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-6">
                <label class="form-label">Producttype</label>
                <select [ngClass]="{'is-invalid': errors['type']}" class="form-select" [(ngModel)]="item['type']">
                    <option *ngFor="let option of productTypeOptions" [value]="option['id']">
                        {{option['name']}}
                    </option>
                </select>
            </div>
            <div class="col-6">
                <label class="form-label">Status</label>
                <select class="form-select" [(ngModel)]="item['status']">
                    <ng-container *ngFor="let status of statusList">
                        <option [value]="status['id']">
                            {{status['name']}}
                        </option>
                    </ng-container>
                </select>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <label class="form-label">Verzendcategorie</label>
                <select [ngClass]="{'is-invalid': errors['shipping_category']}" class="form-select"
                    [(ngModel)]="item['shipping_category']">
                    <option *ngFor="let option of shippingCategoryOptions" [value]="option['id']">
                        {{option['name']}}
                    </option>
                </select>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <label class="form-label">Korte omschrijving</label>
                <input required [ngClass]="{'is-invalid': errors['short_description']}" type="text"
                    [(ngModel)]="item['short_description']" class="form-control" placeholder="">
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <label class="form-label">Lange omschrijving</label>
                <textarea required [ngClass]="{'is-invalid': errors['long_description']}" type="text"
                    [(ngModel)]="item['long_description']" class="form-control" placeholder=""></textarea>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-6">
                <label class="form-label">Gepubliceerd op</label>
                <input [ngClass]="{'is-invalid': errors['first_published_date']}" type="date"
                    [(ngModel)]="formattedFirstPublishedDate" class="form-control" placeholder="">
            </div>
            <div class="col-6">
                <label class="form-label">End of life</label>
                <input [ngClass]="{'is-invalid': errors['end_of_life_date']}" type="date"
                    [(ngModel)]="formattedEndOfLifeDate" class="form-control" placeholder="">
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <label class="form-label">Copyright</label>

                <select [ngClass]="{'is-invalid': errors['copyright']}" class="form-select"
                    [(ngModel)]="item['copyright']">
                    <option *ngFor="let option of copyrightOptions">{{option}}</option>
                </select>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <label class="form-label">Uitgever</label>
                <input [ngClass]="{'is-invalid': errors['publisher']}" type="text" [(ngModel)]="item['publisher']"
                    class="form-control" placeholder="">
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <label class="form-label">Editie</label>
                <input [ngClass]="{'is-invalid': errors['edition']}" type="text" [(ngModel)]="item['edition']"
                    class="form-control" placeholder="">
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <label class="form-label">Proeflicentie link</label>
                <input [ngClass]="{'is-invalid': errors['trial_url']}" type="text" [(ngModel)]="item['trial_url']"
                    class="form-control" placeholder="">
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-6">
                <label class="form-label">Te koop</label>
                <div class="d-flex">
                    <div class="form-check me-5">
                        <input class="form-check-input" id="for_sale_no" type="radio" name="for_sale"
                            [(ngModel)]="item['for_sale']" [value]="1">
                        <label class="form-check-label" for="for_sale_no">Ja</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" id="for_sale_yes" type="radio" name="for_sale"
                            [(ngModel)]="item['for_sale']" [value]="0">
                        <label class="form-check-label" for="for_sale_yes">Nee</label>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <label class="form-label">Is demo</label>
                <div class="d-flex">
                    <div class="form-check me-5">
                        <input class="form-check-input" id="is_demo_no" type="radio" name="is_demo"
                            [(ngModel)]="item['is_demo']" [value]="1">
                        <label class="form-check-label" for="is_demo_no">Ja</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" id="is_demo_yes" type="radio" name="is_demo"
                            [(ngModel)]="item['is_demo']" [value]="0">
                        <label class="form-check-label" for="is_demo_yes">Nee</label>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-buttons">
            <button type="button" class="btn btn-primary" (click)="save()">
                <span *ngIf="!item['id']">Toevoegen</span>
                <span *ngIf="item['id']">Opslaan</span>
            </button>
        </div>
    </div>
</div>
